import { createTheme, ThemeProvider as MaterialUiThemeProvider } from '@mui/material/styles'
import { Themes } from '@loadsmart/loadsmart-ui/dist/theming'
import { ThemeProvider } from 'styled-components'

export interface CustomThemeProviderProps {
  children?: any
}

const customizedTheme = createTheme({
  zIndex: {
    appBar: 1,
  },
  typography: {
    fontFamily: 'Sharp Sans',
    h5: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
    },
    h6: {
      fontSize: '0.9rem',
    },
  },
  palette: {
    primary: {
      main: '#28d454',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#333b43',
    },
    text: {
      primary: '#333b43',
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          overflow: 'inherit',
        },
      },
    },
  },
})

const CustomThemeProvider = ({ children }: CustomThemeProviderProps) => (
  <MaterialUiThemeProvider theme={customizedTheme}>
    <ThemeProvider theme={Themes.Loadsmart}>{children}</ThemeProvider>
  </MaterialUiThemeProvider>
)

export default CustomThemeProvider
